export const PROMPT_BRIDGE_ASSISTANT_CHAT_PATH = '/api/v1/assistant/chat';
